// This code is inspired by the ReactNative App
import { Video } from "@/api";
import { APP_ID } from "@/env.ts";

export const checkVideoUrl = async (url: string) => {
  try {
    const response = await fetch(url);
    if (!response.ok) {
      return false;
    }
    const contentType = response.headers.get("content-type");
    const videoContentTypes = [
      "video/",
      "application/x-mpegurl",
      "application/vnd.apple.mpegurl",
      "application/dash+xml",
      "application/vnd.ms-sstr+xml", // for Smooth Streaming
      "application/octet-stream", // often used for binary video data
    ];

    // Check if content-type matches a video content-type, case-insensitive
    const lowerCaseContentType = contentType ? contentType.toLowerCase() : "";
    return videoContentTypes.some((videoType) =>
      lowerCaseContentType.includes(videoType.toLowerCase()),
    );
  } catch (error) {
    console.debug("Error checking video URL:", error);
    return false;
  }
};

export const isLiveVideo = ({ Properties }: Pick<Video, "Properties">) => {
  return !!Properties?.LiveEventStartDate || !!Properties?.LiveEventEnded;
};

export const checkVideoFile = ({
  OriginalFilename,
}: Pick<Video, "OriginalFilename">) => {
  if (!OriginalFilename) return "";
  if (OriginalFilename.toLowerCase().endsWith("pdf")) {
    return "PDF";
  } else if (OriginalFilename.toLowerCase().endsWith("png")) {
    return "PNG";
  } else if (OriginalFilename.toLowerCase().endsWith("mp3")) {
    return "MP3";
  } else if (OriginalFilename.toLowerCase().endsWith("wav")) {
    return "WAV";
  } else if (OriginalFilename.toLowerCase().endsWith("jpg")) {
    return "JPG";
  }
  return "";
};

export const downloadFile = (file: string) => {
  const prefix = `https://storage.vidapp.com/${APP_ID}/`;
  const url = file.startsWith("http") ? file : `${prefix}${file}`;

  const link = document.createElement("a");
  link.href = url;
  link.download;
  link.target = "_blank";
  link.rel = "noopener noreferrer";
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
};
